import { SocialIcon } from "react-social-icons";

import { IconBadgeTooltip } from "./iconBadgeTooltip";

function sourceInitials(sourceName: string): string {
  return sourceName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

function sourceIconUrl(sourceName: string): string | undefined {
  switch (sourceName.toLowerCase()) {
    case "facebook":
      return "https://facebook.com";
    case "instagram":
      return "https://instagram.com";
    case "linkedin":
      return "https://linkedin.com";
    case "tiktok":
      return "https://tiktok.com";
    case "twitter":
    case "x":
      return "https://x.com";
    case "youtube":
      return "https://youtube.com";
    case "reddit":
      return "https://reddit.com";
    case "bluesky":
      return "https://bsky.app";
    default:
      return undefined;
  }
}

export function SourceBadge({ sourceName }: { sourceName: string }) {
  const iconUrl = sourceIconUrl(sourceName);
  if (iconUrl) {
    return (
      <IconBadgeTooltip
        label={sourceName}
        className="inline-flex h-7 w-7 shrink-0 items-center justify-center"
      >
        <SocialIcon
          url={iconUrl}
          style={{ height: 28, width: 28 }}
          onClick={(event) => event.preventDefault()}
        />
      </IconBadgeTooltip>
    );
  }

  return (
    <IconBadgeTooltip
      label={sourceName}
      className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-green-600 bg-green-50 text-[10px] font-bold text-green-700"
    >
      {sourceInitials(sourceName)}
    </IconBadgeTooltip>
  );
}

export type SourceDisplayMode = "icon" | "text";

export function SourceCell({
  rowSourceNames,
  displayMode = "icon",
}: {
  rowSourceNames: string[];
  displayMode?: SourceDisplayMode;
}) {
  if (rowSourceNames.length === 0) {
    return <span className="text-gray-400">None</span>;
  }
  if (displayMode === "text") {
    return (
      <div className="text-xs text-gray-600">{rowSourceNames.join(", ")}</div>
    );
  }
  return (
    <div className="flex flex-wrap gap-1">
      {rowSourceNames.map((sourceName) => (
        <SourceBadge key={sourceName} sourceName={sourceName} />
      ))}
    </div>
  );
}
